import React, { forwardRef } from 'react'
import styles from '../styles'

const Input = forwardRef((props, ref) => {
  return (
    <div className={`${props.width ? props.width : 'w-full lg:w-1/2'} ${!props.nolabel && 'flex flex-col gap-1 xxl:gap-3'} `}>
      {props.nolabel ? <></> : <><label className='text-inputcolor font-semibold text-[18px] xxxxl:text-[24px]' htmlFor="">{props.label}</label></>}
      {props.textArea ?
      <textarea className={`${styles.input2} h-40 lg:h-52 xxxl:h-68 xxxxl:h-72 `} value={props.value} onInput={props.onInput} id={props.id} ref={ref} style={{resize: 'none'}}/>
      : <input className={!props.newstyle ? styles.input : styles.input2} value={props.value} onInput={props.onInput} id={props.id} type={props.type} placeholder={props.text} ref={ref}/> }
      
    </div>
  )
})

export default Input